import useIsPhone from 'modules/website/hooks/useIsPhone';
import { useEffect, useRef, useState } from 'react';

export default function MapaCatalunya() {
  const [playing, setPlaying] = useState(false);
  const isPhone = useIsPhone();

  const gifRef = useRef(null);
  const timeoutIdRef = useRef(null);

  const gifSrc = 'http://web.junts.cat/wp-content/uploads/2024/01/mapa-cat-territori.gif';
  const staticSrc = 'http://web.junts.cat/wp-content/uploads/2024/01/frame_135_delay-0.04s.gif';

  useEffect(() => {
    const options = {};

    const observer = new IntersectionObserver((entries) => {
      setPlaying(entries[0].isIntersecting);
    }, options);

    observer.observe(gifRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (playing) {
      timeoutIdRef.current = setTimeout(() => setPlaying(false), 5000);
    } else {
      clearTimeout(timeoutIdRef.current);
    }

    return () => {
      clearTimeout(timeoutIdRef.current);
    };
  }, [playing]);

  return (
    <div className="mapacatalunya__container">
      <img
        ref={gifRef}
        src={playing ? gifSrc : staticSrc}
        alt="mapa"
        className="mapacatalunya-gif"
        style={{ objectFit: 'cover', height: isPhone ? 400 : 500 }}
      />
    </div>
  );
}
